import React, { memo, useEffect, useRef, useState } from "react";
import EditorJS from "@editorjs/editorjs";
import { ip } from "../api/api";
/* Tools */
import Paragraph from "@editorjs/paragraph";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Link from "@editorjs/link";
import CustomImageTool from "../customEditorJS/imageTool";
import BoldTool from "../customEditorJS/boldTool";

import Alert from 'editorjs-alert';
import editorjsColumns from "@calumk/editorjs-columns";

import DragDrop from "editorjs-drag-drop";
import IndentTune from 'editorjs-indent-tune'
import AlignmentBlockTune from "editorjs-text-alignment-blocktune";
import TextVariantTune from '@editorjs/text-variant-tune';
import ColorPlugin from 'editorjs-text-color-plugin';
import Accordion from 'editorjs-collapsible-block';



export function TextViewer({ data }) {
  const ref = useRef();
  const editorblock = "CV-" + Math.floor(Math.random() * 99999999).toString();

  useEffect(() => {
      if (!ref.current) {
          const editor = new EditorJS({
              holder: editorblock,
              tools: EDITOR_JS_TOOLS,
              data: data,
              placeholder: "Begin met typen...",
              readOnly: true,
          });
          ref.current = editor;
      }

      return () => {
          if (ref.current && ref.current.destroy) {
              ref.current.destroy();
          }
      };
  }, []);

  return <div className="wysiswyg-viewer"><div id={editorblock} /></div>;
};

let column_tools = {
  header: {
    class: Header,
    inlineToolbar: ['bold', 'italic', 'Color', 'Marker', 'link'],
    toolbox: { title: 'Kop' },
    tunes: ["anyTuneName", "textVariant", "indentTune"]
  },
  paragraph: {
    class: Paragraph,
    inlineToolbar: ['bold', 'italic', 'link', 'Color', 'Marker'],
    toolbox: { title: 'Tekst' },
    tunes: ["anyTuneName", "textVariant", "indentTune"]
  },
  list: {
    class: List,
    toolbox: { title: "Lijst" }
  },
  image: {
    class: CustomImageTool,
    toolbox: { title: "Afbeelding" }
  },
  Color: {
    class: ColorPlugin,
    toolbox: { title: "Kleur" },
    config: {
      colorCollections: [
        '#EC7878','#9C27B0','#673AB7','#3F51B5','#0070FF','#03A9F4','#00BCD4','#4CAF50','#8BC34A','#CDDC39', '#FFC107',
        '#FF9800','#FF5722','#795548','#9E9E9E','#607D8B','#000000','#ffffff'
      ],
      defaultColor: '#FF1300',
      type: 'text',
      customPicker: true
    }
  },
  Marker: {
    class: ColorPlugin,
    toolbox: { title: "Marker" },
    config: {
      defaultColor: '#FFBF00',
      type: 'marker',
    }
  },
  indentTune: {
    class: IndentTune,
    toolbox: { title: "Inspringen" },
    version: EditorJS.version,
  },
  anyTuneName: {
    class:AlignmentBlockTune,
    toolbox: { title: "Uitlijnen" },
    config:{
      default: "left",
    },
  },
  textVariant: {
    class: TextVariantTune,
    toolbox: { title: "Variant" },
  },
  accordion: {
    class: Accordion,
    toolbox: { title: "Accordion" },
    config: {
      defaultExpanded: false,
      maxBlockCount: 10,
      // reduce animation to avoid rendering glitches
      disableAnimation: true,
    },
  },
}

export const EDITOR_JS_TOOLS = {
  header: {
    class: Header,
    inlineToolbar: ['bold', 'italic', 'Color', 'Marker'],
    toolbox: { title: 'Kop' },
    tunes: ["anyTuneName", "textVariant", "indentTune"]
  },
  indentTune: {
      class: IndentTune,
      toolbox: { title: "Inspringen" },
      version: EditorJS.version,
  },
  paragraph: {
    class: Paragraph,
    inlineToolbar: ['bold', 'italic', 'link', 'Color', 'Marker'],
    toolbox: { title: 'Tekst' },
    tunes: ["anyTuneName", "textVariant", "indentTune"]
  },
  list: {
    class: List,
    toolbox: { title: "Lijst" }
  },
  image: {
    class: CustomImageTool,
    toolbox: { title: "Afbeelding" }
  },
  Color: {
    class: ColorPlugin,
    toolbox: { title: "Kleur" },
    config: {
      colorCollections: [
        '#EC7878','#9C27B0','#673AB7','#3F51B5','#0070FF','#03A9F4','#00BCD4','#4CAF50','#8BC34A','#CDDC39', '#FFC107',
        '#FF9800','#FF5722','#795548','#9E9E9E','#607D8B','#000000','#ffffff'
      ],
      defaultColor: '#FF1300',
      type: 'text',
      customPicker: true
    }
  },
  Marker: {
    class: ColorPlugin,
    toolbox: { title: "Marker" },
    config: {
      defaultColor: '#FFBF00',
      type: 'marker',
      icon: `<svg fill="#000000" height="200px" width="200px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M17.6,6L6.9,16.7c-0.2,0.2-0.3,0.4-0.3,0.6L6,23.9c0,0.3,0.1,0.6,0.3,0.8C6.5,24.9,6.7,25,7,25c0,0,0.1,0,0.1,0l6.6-0.6 c0.2,0,0.5-0.1,0.6-0.3L25,13.4L17.6,6z"></path> <path d="M26.4,12l1.4-1.4c1.2-1.2,1.1-3.1-0.1-4.3l-3-3c-0.6-0.6-1.3-0.9-2.2-0.9c-0.8,0-1.6,0.3-2.2,0.9L19,4.6L26.4,12z"></path> </g> <g> <path d="M28,29H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h24c0.6,0,1,0.4,1,1S28.6,29,28,29z"></path> </g> </g></svg>`
    }
  },
  columns : {
    class : editorjsColumns,
    config : {
      EditorJsLibrary : EditorJS,
      tools : column_tools,
      onInit: (editor) => {
        // try to enable drag-drop inside nested column editors if the plugin supports an init hook
        try {
          new DragDrop(editor);
        } catch (e) {
          // noop
        }
      }
    },
    toolbox: { title: "Kolommen" }
  },
  anyTuneName: {
    class:AlignmentBlockTune,
    toolbox: { title: "Uitlijnen" },
    config:{
      default: "left",
    },
  },
  textVariant: TextVariantTune,
  accordion: {
    class: Accordion,
    toolbox: { title: "Accordion" },
    config: {
      defaultExpanded: false,
      maxBlockCount: 10,
      disableAnimation: true,
    },
  },
}


/* Editor component */

export function TextEditor({ read = false, data, onChange, defaultData, placeholder = "Begin met typen..." }) {
  const editorRef = useRef(null);

  return (
    <EditorWrapper// force remount when defaultData changes
      read={read}
      data={defaultData}
      onChange={onChange}
      placeholder={placeholder}
      editorRef={editorRef}
    />
  );
}

function EditorWrapper({ read, data, onChange, placeholder, editorRef }) {
  var editorInstance = useRef(null);
  useEffect(() => {
    if (!editorInstance.current) {
     editorInstance.current = new EditorJS({
      holder: editorRef.current,
      tools: EDITOR_JS_TOOLS,
      data,
      placeholder,
      readOnly: read,
      autofocus: !read, // only autofocus in edit mode
      onReady: () => {
        if (!read) {
          new DragDrop(editorInstance.current);
        }
      },
      async onChange(api) {
        if(!read){
            const savedData = await api.saver.save();
            onChange?.(savedData);
        }
      },
    });
  } 
    return () => {
        if (editorInstance.current && typeof editorInstance.current.destroy === 'function'){
        editorInstance.current.destroy()
        editorInstance.current = null
      }
    };
  // re-create when data or read mode changes
  }, [data, read]);

  return <div className={read?'wysiswyg-viewer':'wysiswyg-editor'} style={{height:read?'':"max-content"}} ref={editorRef} />;
}

